"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.startEventTracking = void 0;

var _globalEventTracker = require("./globalEventTracker");

/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal
 */

/**
 * start global tracking listener
 *
 */
var startEventTracking = function startEventTracking() {
  document.addEventListener('click', _globalEventTracker.globalEventTracker);
};

exports.startEventTracking = startEventTracking;